import { render } from "./TheHeader.vue?vue&type=template&id=5587e06a&scoped=true&ts=true"
import script from "./TheHeader.vue?vue&type=script&lang=ts"
export * from "./TheHeader.vue?vue&type=script&lang=ts"

import "./TheHeader.vue?vue&type=style&index=0&id=5587e06a&scoped=true&lang=css"

import exportComponent from "/container/procurement-dev.jd.net.nz/application/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5587e06a"]])

export default __exports__